/** True when `pathname` is `href`'s path or lies beneath it (whole segments only). */
export function matchesPathSegments(pathname: string, href: string): boolean {
  const path = href.split('?')[0];
  return pathname === path || pathname.startsWith(path.endsWith('/') ? path : `${path}/`);
}
